import moment from 'moment';
import DateUtil from '../utils/DateUtil';
import {eigenleistungPrefix, TSEigenleistungArt} from './enums/TSEigenleistungArt';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSEigenleistungDaten extends TSAbstractEntity implements TSSerializable<TSEigenleistungDaten> {

    private _vorname: string;

    private _name: string;

    private _jahrgang: number;

    private _description: string;

    private _eigenleistungArt: TSEigenleistungArt;

    private _arbeitsstunden: number;

    private _betrag: number;

    private _datum: moment.Moment | undefined;

    public get displayName() {
        let dispName;
        switch (this.eigenleistungArt) {

            case TSEigenleistungArt.ANDERE:
                dispName = this.description;
                break;
            case TSEigenleistungArt.HANDARBEIT:
                dispName = this.vorname + ' ' + this.name + ' (' + this.jahrgang + ')'
                break;
            default:
                dispName = eigenleistungPrefix() + this.eigenleistungArt;
                break;
        }
        return dispName;
    }

    public get vorname(): string {
        return this._vorname;
    }

    public set vorname(value: string) {
        this._vorname = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get jahrgang(): number {
        return this._jahrgang;
    }

    public set jahrgang(value: number) {
        this._jahrgang = value;
    }

    public get description(): string {
        return this._description;
    }

    public set description(value: string) {
        this._description = value;
    }

    public get eigenleistungArt(): TSEigenleistungArt {
        return this._eigenleistungArt;
    }

    public set eigenleistungArt(value: TSEigenleistungArt) {
        this._eigenleistungArt = value;
    }

    public get arbeitsstunden(): number {
        return this._arbeitsstunden;
    }

    public set arbeitsstunden(value: number) {
        this._arbeitsstunden = value;
    }

    public get betrag(): number {
        return this._betrag;
    }

    public set betrag(value: number) {
        this._betrag = value;
    }

    public get datum(): moment.Moment | any {
        return this._datum;
    }

    public set datum(value: moment.Moment | any) {
        this._datum = value;
    }

    deserialize(restObject: any): TSEigenleistungDaten {
        super.deserialize(restObject);

        this.vorname = restObject.vorname;
        this.name = restObject.name;
        this.jahrgang = restObject.jahrgang;
        this.description = restObject.description;
        this.eigenleistungArt = restObject.eigenleistungArt;
        this.arbeitsstunden = restObject.arbeitsstunden;
        this.betrag = restObject.betrag;

        this.datum = DateUtil.localDateToMoment(restObject.datum);

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.vorname = this.vorname;
        restObject.name = this.name;
        restObject.jahrgang = this.jahrgang;
        restObject.description = this.description;
        restObject.eigenleistungArt = this.eigenleistungArt;
        restObject.arbeitsstunden = this.arbeitsstunden;
        restObject.betrag = this.betrag;

        if (this.datum) {
            restObject.datum = DateUtil.momentToLocalDate(this.datum);
        }

        return restObject;
    }

    public isHolz(): boolean {
        return this.eigenleistungArt === TSEigenleistungArt.HOLZ ||
            this.eigenleistungArt === TSEigenleistungArt.HOLZ_AUF_PLATZ;
    }

    public isTreibstoff(): boolean {
        return this.eigenleistungArt === TSEigenleistungArt.TREIBSTOFF;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSEigenleistungDaten.ts